<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">List of - Receiving Invoice with Term        
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
          <b-form-group label-cols=3 label="Order Number">
              <b-row>
                <b-col class="pr-1" cols="6"><b-form-input v-model="tblData.nomor" placeholder="Order Number"></b-form-input></b-col>
                <b-col class="pl-1" cols="6"><b-form-input v-model="tblData.requestno" placeholder="Request Number"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Dimension Name">
              <b-row>
                <b-col class="pr-1" cols="6"><b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select></b-col>
                <b-col class="pl-1" cols="6"><b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Trx. Date">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input></b-col>
                <b-col class="pl-1" cols="4"><b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input></b-col>
                <b-col class="pl-1" cols="4">
                  <b-input-group >
                      <b-input-group-prepend><label style="text-align: left; width:40px;">Status</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="approvalStatus"></b-form-select>
                  </b-input-group >
                </b-col>
              </b-row>                      
          </b-form-group>

        </b-col>
        <b-col md="6">
          <b-form-group label-cols=3 label="Vendor/Supplier">
              <b-row>
                <b-col class="pr-1" cols="6"><b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input></b-col>
                <b-col class="pl-1" cols="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="text-align: left; width:40px;">Group</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
                  </b-input-group >
              </b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Description">
              <b-form-input v-model="tblData.uraian"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3  label="Item Name/Desc.">
              <b-row>
                <b-col class="pr-1" cols="7">
                    <b-form-input v-model="tblData.item" placeholder="Material/Service Name"></b-form-input>                  
                </b-col>
                <b-col class="pr-1" cols="5">
                  <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-col>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(komplitDate)="data">
          <!--  Noete :
          tidak ada return untuk data.item.RecivDate  
          -->
          {{ data.item.komplitDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(namaterm)="data">
          <span></span>{{ data.item.namaterm }} &nbsp; {{ data.item.persentase }} %
        </template>

        <template v-slot:cell(nilai)="data">
          {{data.item.nilai | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Send to Workflow for Approval Process?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Sent to Workflow for Approval Process?</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import procure from "../../apis/procure";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        DimCol:'Dim1'
      },
      model:{},
      postGroups:[],
      approvalStatus : dropdown.approvalStatus
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "orderno",
            thStyle: "width:150px",
            label: "Order Number"
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "Order Date"
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "namaterm",
            thStyle: "width:100px",
            label: "Term of",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilai",
            label: "Value",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "syarat",
            label: "Term Condition/Document Required",
          },
          {
            key: "komplitDate",
            thStyle: "width:90px",
            label: "Complete Date"
          },
          {
            key: "komplitBy",
            thStyle: "width:90px",
            label: "Received By",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      const accList = await procure.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.invtermlist) {
            this.tblData[key] = filter.invtermlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.invtermlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await procure.listinvtermin(this.tblData); 
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.item=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.requestno=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';

        this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      const filter = this.$store.state.filter;
      filter.invtermlist=this.tblData;
      this.$store.commit("filter", filter);
      router.push("invoice-termin-form");
    },
    edit: function() {
        if (this.model) {
          const filter = this.$store.state.filter;
          filter.invtermlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'procurement.invoicetermfrm', params: { pohdrkey:this.model.pohdrkey,potermkey: this.model.potermkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
      console.log('delete confirm : ',this.model);
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await procure.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model.potermkey == record.potermkey) {
          this.edit();
      } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    posting: async function () {
        if (this.model) {
            if ((this.model.send2wf || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.send2wf == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await procure.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await procure.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await procure.invterminprint(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await procure.invterminexportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("home");
    }

  }
};
</script>
